import { Switch } from "antd";
import { ReactComponent as CheckIcon } from "../Assets/icons/check.svg";
import { ReactComponent as CloseSmallIcon } from "../Assets/icons/close_small.svg";
import spaIcon from "../Assets/icons/spa.svg";
import NeedSlider from "./NeedSlider";

const Needs = ({
  categories = [],
  selectedValues,
  setSelectedValues,
  showMedecinDouce = true,
  alternativeMedicineEnabled,
  onMedecinDouceChange,
  translate,
  needsLevels = 5,
  labels = {},
  categoriesConfig = {},
}) => {
  const handleChange = (category, value) => {
    setSelectedValues((prev) => ({ ...prev, [category.value]: value }));
  };

  const descriptionPrefix =
    translate?.MEDECIN_DOUCE?.DESCRIPTION_PREFIX || "Prise en charge";
  const descriptionSuffix =
    translate?.MEDECIN_DOUCE?.DESCRIPTION_SUFFIX ||
    "des dépenses en médecines douces";

  return (
    <div className="acoris-needs">
      <div className="acoris-needs__list">
        {categories.map((category) => (
          <NeedSlider
            key={category.value}
            category={category}
            value={selectedValues[category.value] || 1}
            onChange={(value) => handleChange(category, value)}
            translate={translate}
            needsLevels={needsLevels}
            labels={labels}
            categoriesConfig={categoriesConfig}
          />
        ))}
      </div>

      {showMedecinDouce && (
        <div className="acoris-needs__medecin-douce">
          <div className="acoris-needs__medecin-douce-info">
            <img
              src={spaIcon}
              alt=""
              className="acoris-needs__medecin-douce-icon"
            />
            <span className="acoris-needs__medecin-douce-title">
              {translate?.MEDECIN_DOUCE?.TITLE || "Bien-être"}
            </span>
            <span className="acoris-needs__medecin-douce-description">
              <strong>{descriptionPrefix}</strong>
              {` ${descriptionSuffix}`}
            </span>
          </div>
          <Switch
            checked={alternativeMedicineEnabled}
            onChange={onMedecinDouceChange}
            className="acoris-needs__medecin-douce-switch"
            checkedChildren={<CheckIcon />}
            unCheckedChildren={<CloseSmallIcon />}
          />
        </div>
      )}
    </div>
  );
};

export default Needs;
